import { render, staticRenderFns } from "./TeamSection.vue?vue&type=template&id=85eb5f20&scoped=true"
import script from "./TeamSection.vue?vue&type=script&lang=js"
export * from "./TeamSection.vue?vue&type=script&lang=js"
import style0 from "./TeamSection.vue?vue&type=style&index=0&id=85eb5f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eb5f20",
  null
  
)

export default component.exports